// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var $$String = require("rescript/lib/js/string.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Rect$SmartcutsMacros = require("./Rect.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
var Webapi__Dom__HtmlElement = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.js");
var DOM__Node$SmartcutsMacros = require("./DOM__Node.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var DOM__Shadow$SmartcutsMacros = require("./DOM__Shadow.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var PlaybackModal$SmartcutsMacros = require("./app/PlaybackModal.bs.js");

function maybeInnerText(element) {
  return Caml_option.nullable_to_opt(element.innerText);
}

function checkSelectionStartCapability(element) {
  var match = element.nodeName;
  switch (match) {
    case "INPUT" :
        var match$1 = element.type;
        switch (match$1) {
          case "email" :
          case "number" :
              return false;
          case "password" :
          case "search" :
          case "tel" :
          case "text" :
          case "url" :
              return true;
          default:
            return false;
        }
    case "TEXTAREA" :
        return true;
    default:
      return false;
  }
}

function innerTextGet(domElement) {
  var text = domElement.innerText;
  if (text === "") {
    return ;
  } else {
    return text;
  }
}

function toHtmlInputElement(element) {
  var match = $$String.lowercase_ascii(element.nodeName);
  if (match === "input") {
    return Caml_option.some(element);
  }
  
}

function getTextContent(element) {
  var match = $$String.lowercase_ascii(element.nodeName);
  if (match !== "input") {
    return innerTextGet(element);
  }
  var match$1 = $$String.lowercase_ascii(element.type);
  switch (match$1) {
    case "email" :
    case "password" :
    case "search" :
    case "tel" :
    case "text" :
    case "url" :
        return element.value;
    default:
      return ;
  }
}

function idGet(domElement) {
  var id = domElement.id;
  if (id === "") {
    return ;
  } else {
    return id;
  }
}

function isNotVisibleOnPage(element) {
  var domRect = element.getBoundingClientRect();
  if (domRect.height <= 1.0) {
    return true;
  } else {
    return domRect.width <= 1.0;
  }
}

function isVisibleOnPage(element) {
  return !isNotVisibleOnPage(element);
}

function isVisibleInViewport(element) {
  var domRect = element.getBoundingClientRect();
  var left = domRect.left;
  var top = domRect.top;
  var bottom = domRect.bottom;
  var right = domRect.right;
  if (left > 0 && top > 0 && bottom < window.innerHeight) {
    return right < window.innerWidth;
  } else {
    return false;
  }
}

function getClientXAndClientYOfCenterOfElement(element) {
  var rect = element.getBoundingClientRect();
  var left = rect.left;
  var top = rect.top;
  var width = rect.width;
  var height = rect.height;
  var clientX = left + width / 2;
  var clientY = top + height / 2;
  return [
          clientX,
          clientY
        ];
}

function ancestorNodes(element) {
  var ancestorsRef = [];
  var nodeRef = element;
  var $$break = false;
  while(!$$break) {
    var node = nodeRef;
    ancestorsRef = $$Array.append([node], ancestorsRef);
    var match = Webapi__Dom__Node.nodeType(node);
    var maybeParentNode = match !== 10 ? Caml_option.nullable_to_opt(node.parentNode) : Caml_option.some(node.host);
    if (maybeParentNode !== undefined) {
      nodeRef = Caml_option.valFromOption(maybeParentNode);
    } else {
      $$break = true;
    }
  };
  return ancestorsRef;
}

function ancestorElements(element) {
  return $$Array.to_list(Belt_Array.keepMap(ancestorNodes(element), Webapi__Dom__Element.ofNode));
}

var contains = DOM__Node$SmartcutsMacros.contains;

function isAttached(element) {
  return contains(document.documentElement, element);
}

var isUndefined = (function (a) {return typeof a == "undefined";});

var getPathTo = (function getPathTo(element) {
    if (element.id!=='')
        return 'id("'+element.id+'")';
    if (element===document.body)
        return element.tagName;

    var ix= 0;
    var siblings= element.parentNode.childNodes;
    for (var i= 0; i<siblings.length; i++) {
        var sibling= siblings[i];
        if (sibling===element)
            return getPathTo(element.parentNode)+'/'+element.tagName+'['+(ix+1)+']';
        if (sibling.nodeType===1 && sibling.tagName===element.tagName)
            ix++;
    }
});

function commonAncestor(elementA, elementB) {
  if (elementA === elementB) {
    return elementA;
  }
  if (contains(elementA, elementB)) {
    return elementA;
  }
  if (contains(elementB, elementA)) {
    return elementB;
  }
  var ancestorElementsA = ancestorElements(elementA);
  var ancestorElementsB = ancestorElements(elementB);
  var match = List.length(ancestorElementsA) > List.length(ancestorElementsB) ? [
      ancestorElementsA,
      ancestorElementsB
    ] : [
      ancestorElementsB,
      ancestorElementsA
    ];
  var shorterAncestors = match[1];
  var arg = ListUtils$SmartcutsMacros.shortcutWithIndex((function (ancestor_1, index) {
          var match = ListUtils$SmartcutsMacros.elemIndex(ancestor_1, shorterAncestors);
          if (match !== undefined) {
            return ;
          } else {
            return Belt_List.get(shorterAncestors, index - 1 | 0);
          }
        }), match[0]);
  var param = "Expected to find common ancestor of two elements";
  return OptionUtils$SmartcutsMacros.getExn(param, arg);
}

function isContentEditable(element) {
  var htmlElement = Webapi__Dom__HtmlElement.ofElement(element);
  if (htmlElement !== undefined) {
    return Caml_option.valFromOption(htmlElement).isContentEditable;
  } else {
    return false;
  }
}

function compare(elementA, elementB) {
  if (elementA === elementB) {
    return 0;
  }
  var match = contains(document.documentElement, elementA);
  var match$1 = contains(document.documentElement, elementB);
  if (!match) {
    if (match$1) {
      return -1;
    } else {
      return Util$SmartcutsMacros.logAndRaiseJsError("Unexpect: doesn't make sense to compare two detached nodes");
    }
  }
  if (!match$1) {
    return 1;
  }
  var ancestorElementsA = ancestorElements(elementA);
  var ancestorElementsB = ancestorElements(elementB);
  var _commonNode;
  var _ancestorsA = ancestorElementsA;
  var _ancestorsB = ancestorElementsB;
  while(true) {
    var ancestorsB = _ancestorsB;
    var ancestorsA = _ancestorsA;
    var commonNode = _commonNode;
    if (!ancestorsA) {
      if (ancestorsB) {
        return -1;
      } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected elementA to not equal element B");
      }
    }
    var ancestorA = ancestorsA.hd;
    if (!ancestorsB) {
      return 1;
    }
    var ancestorB = ancestorsB.hd;
    if (ancestorA === ancestorB) {
      _ancestorsB = ancestorsB.tl;
      _ancestorsA = ancestorsA.tl;
      _commonNode = Caml_option.some(ancestorA);
      continue ;
    }
    var commonAncestor = OptionUtils$SmartcutsMacros.getExn("Expect to get commonAncestor", commonNode);
    var siblings = Array.prototype.slice.call(commonAncestor.childNodes);
    var arg = Util$SmartcutsMacros.shortcut2(siblings, (function(ancestorA,ancestorB){
        return function (sib) {
          if (sib === ancestorA) {
            return -1;
          } else if (sib === ancestorB) {
            return 1;
          } else {
            return ;
          }
        }
        }(ancestorA,ancestorB)));
    var param = "Expected to find ancestorA or ancestorB";
    return OptionUtils$SmartcutsMacros.getExn(param, arg);
  };
}

function isYScrollable(el) {
  return el.scrollHeight > el.clientHeight;
}

function isXScrollable(el) {
  return el.scrollWidth > el.clientWidth;
}

function isScrollable(el) {
  if (isYScrollable(el)) {
    return true;
  } else {
    return isXScrollable(el);
  }
}

function closest(f, _el) {
  while(true) {
    var el = _el;
    var parentEl = el.parentElement;
    if (parentEl == null) {
      return ;
    }
    if (Curry._1(f, parentEl)) {
      return Caml_option.some(parentEl);
    }
    _el = parentEl;
    continue ;
  };
}

function closestSome(f, _el) {
  while(true) {
    var el = _el;
    var parentEl = el.parentElement;
    if (parentEl == null) {
      return ;
    }
    var v = Curry._1(f, parentEl);
    if (v !== undefined) {
      return [
              parentEl,
              Caml_option.valFromOption(v)
            ];
    }
    _el = parentEl;
    continue ;
  };
}

function scrollableClosestParentOrSelf(param) {
  return closest(isScrollable, param);
}

function getBoundingClientRectInViewport(element) {
  var boundingRect = Rect$SmartcutsMacros.fromDomRect(element.getBoundingClientRect());
  var windowHeight = window.innerHeight;
  var windowWidth = window.innerWidth;
  var viewport = {
    x: 0.0,
    y: 0.0,
    width: windowWidth,
    height: windowHeight
  };
  return Rect$SmartcutsMacros.intersect(boundingRect, viewport);
}

function isOutsideOfViewport(element) {
  return Rect$SmartcutsMacros.isEmpty(getBoundingClientRectInViewport(element));
}

function scrollIntoViewIfNeeded(xRel, yRel, element) {
  var isPointInsideIntersectionRect = function (xRel, yRel, intersectionRect) {
    if (intersectionRect.width > xRel) {
      return intersectionRect.height > yRel;
    } else {
      return false;
    }
  };
  var boundingClientRectInViewport = getBoundingClientRectInViewport(element);
  if (Rect$SmartcutsMacros.isNotEmpty(boundingClientRectInViewport) && isPointInsideIntersectionRect(xRel, yRel, boundingClientRectInViewport)) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: undefined
              });
  } else {
    return new Promise((function (resolve, param) {
                  var match = Webapi__Dom__Document.visibilityState(document);
                  if (match !== 0) {
                    if (match >= 3) {
                      return resolve({
                                  TAG: /* Error */1,
                                  _0: /* TabOrWindowVisibilityUnknownOrUnloaded */3
                                });
                    } else {
                      return resolve({
                                  TAG: /* Error */1,
                                  _0: /* TabOrWindowNotVisible */2
                                });
                    }
                  }
                  var onIntersectionChange = function (entries, observer) {
                    var hasElementScrolledIntoView = Belt_Array.some(entries, (function (entry) {
                            var target = entry.target;
                            if (target === element) {
                              return entry.isIntersecting;
                            } else {
                              return false;
                            }
                          }));
                    if (hasElementScrolledIntoView) {
                      observer.disconnect();
                      return resolve({
                                  TAG: /* Ok */0,
                                  _0: undefined
                                });
                    }
                    
                  };
                  var observer = new IntersectionObserver(onIntersectionChange, {
                        thresholds: 1.0
                      });
                  observer.observe(element);
                  element.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                      });
                  
                }));
  }
}

function isTopZIndexAtLocation(maybeRelPosition, element, param) {
  var rect = element.getBoundingClientRect();
  var left = rect.left;
  var top = rect.top;
  var width = rect.width;
  var height = rect.height;
  var bottom = rect.bottom;
  var match;
  if (maybeRelPosition !== undefined) {
    var match$1 = maybeRelPosition.parent;
    var parentHeight = match$1.height;
    var parentWidth = match$1.width;
    var xRatio = parentWidth > 0 ? maybeRelPosition.x / parentWidth : 0.5;
    var yRatio = parentHeight > 0 ? maybeRelPosition.y / parentHeight : 0.5;
    match = [
      width * xRatio,
      height * yRatio
    ];
  } else {
    match = [
      width / 2,
      height / 2
    ];
  }
  var x = left + match[0];
  var y = top + match[1];
  var elementAtPoint = document.elementFromPoint(x | 0, y | 0);
  if (elementAtPoint == null) {
    return /* ElementNotInViewport */1;
  }
  if (elementAtPoint === element || contains(elementAtPoint, element) || contains(element, elementAtPoint)) {
    return /* ElementIsTopZIndexAtLocation */0;
  }
  if (Belt_Option.isSome(closest((function (element) {
                var id = element.id;
                return id === PlaybackModal$SmartcutsMacros.PlaybackModal.containerId;
              }), elementAtPoint))) {
    return /* HideSmartcutsPlaybackModalUntilCompletedCommand */2;
  }
  var arg = commonAncestor(elementAtPoint, element);
  var arg$1 = Curry._1((function (param) {
              return function (param$1) {
                return function (param$2) {
                  var findVisibleDescendantContainsElementAtPoint = function (element) {
                    var arg = Array.prototype.slice.call(element.childNodes);
                    var param$3 = function (node) {
                      return Belt_Option.flatMap(Webapi__Dom__Element.ofNode(node), (function (descendant) {
                                    var descendantRect = getBoundingClientRectInViewport(descendant);
                                    if (!contains(descendant, param$2)) {
                                      return ;
                                    }
                                    var tmp = false;
                                    if (Rect$SmartcutsMacros.isNotEmpty(descendantRect)) {
                                      var func = function (param$4, param$5) {
                                        return Rect$SmartcutsMacros.containsPoint(param, param$4, param$5);
                                      };
                                      tmp = Curry._2(func, param$1, descendantRect);
                                    }
                                    if (tmp) {
                                      return Caml_option.some(descendant);
                                    } else {
                                      return findVisibleDescendantContainsElementAtPoint(descendant);
                                    }
                                  }));
                    };
                    return ArrayUtils$SmartcutsMacros.shortcut(param$3, arg);
                  };
                  return findVisibleDescendantContainsElementAtPoint(arg);
                };
              };
            })(x)(y), elementAtPoint);
  var overlay = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("got None from nextVisibleDescendantContainsElementAtPoint");
  var windowHeight = window.innerHeight;
  var overlayRect = Rect$SmartcutsMacros.fromDomRect(overlay.getBoundingClientRect());
  var scrollable = closest(isScrollable, element);
  if (scrollable === undefined) {
    return {
            TAG: /* WaitForOverlayToDisappear */0,
            _0: overlay
          };
  }
  if (overlayRect.height >= windowHeight) {
    return {
            TAG: /* WaitForOverlayToDisappear */0,
            _0: overlay
          };
  }
  var overlayTop = Rect$SmartcutsMacros.top(overlayRect);
  var overlayBottom = Rect$SmartcutsMacros.bottom(overlayRect);
  var distanceToScroll = windowHeight - overlayBottom > overlayTop ? top - overlayBottom : overlayTop - bottom;
  return {
          TAG: /* ScrollToRevealElement */1,
          _0: Caml_option.valFromOption(scrollable),
          _1: distanceToScroll
        };
}

var Style = {};

function waitForAnyPossibleOverlayToDisappear(element, positionRelToElement, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, param) {
  var rect = element.getBoundingClientRect();
  var width = rect.width;
  var height = rect.height;
  var match;
  if (positionRelToElement !== undefined) {
    var match$1 = positionRelToElement.parent;
    var parentHeight = match$1.height;
    var parentWidth = match$1.width;
    var xRatio = parentWidth > 0 ? positionRelToElement.x / parentWidth : 0.5;
    var yRatio = parentHeight > 0 ? positionRelToElement.y / parentHeight : 0.5;
    match = [
      width * xRatio,
      height * yRatio
    ];
  } else {
    match = [
      width / 2,
      height / 2
    ];
  }
  var yRel = match[1];
  var xRel = match[0];
  return Util$SmartcutsMacros.waitForPromise2(10000, 500, (function (param) {
                  var overlayElement = isTopZIndexAtLocation(positionRelToElement, element, undefined);
                  if (typeof overlayElement === "number") {
                    switch (overlayElement) {
                      case /* ElementIsTopZIndexAtLocation */0 :
                          return Promise.resolve({
                                      TAG: /* PredicateSatisfied */0,
                                      _0: undefined
                                    });
                      case /* ElementNotInViewport */1 :
                          return scrollIntoViewIfNeeded(xRel, yRel, element).then(function (result) {
                                      if (result.TAG === /* Ok */0) {
                                        return Promise.resolve(/* PredicateNotSatisfied */0);
                                      } else {
                                        return Promise.resolve({
                                                    TAG: /* ErrorDuringPredicate */2,
                                                    _0: result._0
                                                  });
                                      }
                                    });
                      case /* HideSmartcutsPlaybackModalUntilCompletedCommand */2 :
                          return Curry._1(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function (param) {
                                      return Promise.resolve(/* PredicateNotSatisfied */0);
                                    });
                      
                    }
                  } else {
                    if (overlayElement.TAG === /* WaitForOverlayToDisappear */0) {
                      return Promise.resolve({
                                  TAG: /* PredicateNotSatisfiedWithExtraInfo */1,
                                  _0: overlayElement._0
                                });
                    }
                    overlayElement._0.scrollBy(0.0, overlayElement._1);
                    return Promise.resolve(/* PredicateNotSatisfied */0);
                  }
                })).then(function (result) {
              if (result.TAG === /* Ok */0) {
                var match = result._0;
                switch (match.TAG | 0) {
                  case /* PredicateDidResolveTo */0 :
                      return Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: undefined
                                });
                  case /* TimedOut */1 :
                  case /* PredicateTimedOut */2 :
                      break;
                  
                }
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* OverlayStillBlockingElementAfterMs */5,
                              _0: {
                                element: element,
                                maybeOverlayElement: match._1,
                                ms: match._0
                              }
                            }
                          });
              }
              var jsPromiseError = result._0;
              if (jsPromiseError.TAG === /* UncaughtPredicateError */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* ErrorWhileWaitForPossibleOverlayToDisappear */6,
                              _0: jsPromiseError._0
                            }
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: jsPromiseError._0
                          });
              }
            });
}

function rootElementContainingDifferentInnnerText(element) {
  var elementInnerText = element.innerText;
  var findRootElementContainingDifferentInnerText = function (element) {
    if (element.innerText !== elementInnerText) {
      return Caml_option.some(element);
    } else {
      return Belt_Option.flatMap(Caml_option.nullable_to_opt(element.parentElement), findRootElementContainingDifferentInnerText);
    }
  };
  return findRootElementContainingDifferentInnerText(element);
}

function downMostElementWithSameInnnerText(element) {
  var elementInnerText = element.innerText;
  var _element = element;
  while(true) {
    var element$1 = _element;
    var elements = Belt_Array.keepMap(Array.prototype.slice.call(element$1.childNodes), (function (node) {
            return Belt_Option.flatMap(Webapi__Dom__Element.ofNode(node), (function (childElement) {
                          if (childElement.innerText === elementInnerText) {
                            return Caml_option.some(childElement);
                          }
                          
                        }));
          }));
    if (elements.length === 0) {
      return element$1;
    }
    _element = Caml_array.get(elements, 0);
    continue ;
  };
}

function proximalElementsWithInnerText(element) {
  var elementInnerText = element.innerText;
  var rootElement = rootElementContainingDifferentInnnerText(element);
  if (rootElement !== undefined) {
    return Belt_Array.map(Belt_Array.keepMap(Array.prototype.slice.call(Caml_option.valFromOption(rootElement).childNodes), (function (node) {
                      return Belt_Option.flatMap(Webapi__Dom__Element.ofNode(node), (function (siblingElement) {
                                    if (isNotVisibleOnPage(siblingElement)) {
                                      return ;
                                    }
                                    var innerText = siblingElement.innerText;
                                    var innerText$1 = (innerText == null) ? undefined : Caml_option.some(innerText);
                                    if ((innerText == null) || innerText$1 === "" || contains(siblingElement, element) || innerText$1.length > 100 || innerText$1 === elementInnerText) {
                                      return ;
                                    } else {
                                      return Caml_option.some(siblingElement);
                                    }
                                  }));
                    })), downMostElementWithSameInnnerText);
  } else {
    return [];
  }
}

function hasParent(element) {
  return Caml_option.nullable_to_opt(element.parentElement) !== undefined;
}

var getDepthRelativeToBody = DOM__Node$SmartcutsMacros.getDepthRelativeToBody;

function isActive(element) {
  var activeElement = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
  if (activeElement !== undefined) {
    return Caml_option.valFromOption(activeElement) === element;
  } else {
    return false;
  }
}

function isLikelyAutosuggestResult(htmlInputElement, element) {
  var inputRect = htmlInputElement.getBoundingClientRect();
  var bottomForInput = inputRect.bottom;
  var leftForInput = inputRect.left;
  var widthForInput = inputRect.width;
  var rect = element.getBoundingClientRect();
  var top = rect.top;
  var left = rect.left;
  var width = rect.width;
  var height = rect.height;
  var x = rect.x;
  var y = rect.y;
  var isElementLikelyFirstAutosuggestResultUnderInput = Util$SmartcutsMacros.isFloatWithin(bottomForInput, bottomForInput + 2, top) && Util$SmartcutsMacros.isFloatWithin(leftForInput - 2, leftForInput + 2, left) && Util$SmartcutsMacros.isFloatWithin(widthForInput - 2, widthForInput + 2, width);
  if (isElementLikelyFirstAutosuggestResultUnderInput) {
    return true;
  }
  var elementBelow = Belt_Option.map(Caml_option.nullable_to_opt(document.elementFromPoint(x | 0, y + height / 2 | 0)), (function (prim) {
          return prim;
        }));
  if (elementBelow === undefined) {
    return false;
  }
  var elementBelow$1 = Caml_option.valFromOption(elementBelow);
  if ((width | 0) === elementBelow$1.offsetWidth) {
    return (height | 0) === elementBelow$1.offsetHeight;
  } else {
    return false;
  }
}

function isElementAPositionedGeometricallyInsideElementB(elementA, elementB) {
  var rectA = elementA.getBoundingClientRect();
  var rectB = elementB.getBoundingClientRect();
  var topA = rectA.x;
  var leftA = rectA.y;
  var bottomA = rectA.width;
  var rightA = rectA.height;
  var topB = rectB.x;
  var leftB = rectB.y;
  var bottomB = rectB.width;
  var rightB = rectB.height;
  if (topA >= topB && leftA >= leftB && bottomA <= bottomB) {
    return rightA <= rightB;
  } else {
    return false;
  }
}

function doElementsGeometricallyOverlap(elementA, elementB) {
  var rectA = elementA.getBoundingClientRect();
  var rectB = elementB.getBoundingClientRect();
  var topA = rectA.x;
  var leftA = rectA.y;
  var bottomA = rectA.width;
  var rightA = rectA.height;
  var topB = rectB.x;
  var leftB = rectB.y;
  var bottomB = rectB.width;
  var rightB = rectB.height;
  var isTopAInsideBoundsOfB = topA >= topB && topA <= bottomB;
  var isBottomAInsideBoundsOfB = bottomA <= bottomB && bottomA >= topB;
  var isLeftAInsideBoundsOfB = leftA >= leftB && leftA <= rightB;
  var isRightAInsideBoundsOfB = rightA <= rightB && rightA >= leftB;
  if (isTopAInsideBoundsOfB || isBottomAInsideBoundsOfB || isLeftAInsideBoundsOfB) {
    return true;
  } else {
    return isRightAInsideBoundsOfB;
  }
}

function isSiblingOf(e1, e2) {
  var match = e1.parentElement;
  var match$1 = e2.parentElement;
  if (!(match == null) && !(match$1 == null)) {
    return match === match$1;
  } else {
    return false;
  }
}

var Cell = {};

function getCellAtIndex(row, index) {
  return Caml_option.undefined_to_opt(row.cells[index]);
}

var Row = {
  getCellAtIndex: getCellAtIndex
};

function getRowAtIndex(table, index) {
  return Caml_option.undefined_to_opt(table.rows[index]);
}

var TableElement = {
  Cell: Cell,
  Row: Row,
  getRowAtIndex: getRowAtIndex
};

exports.maybeInnerText = maybeInnerText;
exports.checkSelectionStartCapability = checkSelectionStartCapability;
exports.innerTextGet = innerTextGet;
exports.toHtmlInputElement = toHtmlInputElement;
exports.getTextContent = getTextContent;
exports.idGet = idGet;
exports.isNotVisibleOnPage = isNotVisibleOnPage;
exports.isVisibleOnPage = isVisibleOnPage;
exports.isVisibleInViewport = isVisibleInViewport;
exports.getClientXAndClientYOfCenterOfElement = getClientXAndClientYOfCenterOfElement;
exports.ancestorNodes = ancestorNodes;
exports.ancestorElements = ancestorElements;
exports.contains = contains;
exports.isAttached = isAttached;
exports.isUndefined = isUndefined;
exports.getPathTo = getPathTo;
exports.commonAncestor = commonAncestor;
exports.isContentEditable = isContentEditable;
exports.compare = compare;
exports.isYScrollable = isYScrollable;
exports.isXScrollable = isXScrollable;
exports.isScrollable = isScrollable;
exports.closest = closest;
exports.closestSome = closestSome;
exports.scrollableClosestParentOrSelf = scrollableClosestParentOrSelf;
exports.isOutsideOfViewport = isOutsideOfViewport;
exports.scrollIntoViewIfNeeded = scrollIntoViewIfNeeded;
exports.isTopZIndexAtLocation = isTopZIndexAtLocation;
exports.Style = Style;
exports.waitForAnyPossibleOverlayToDisappear = waitForAnyPossibleOverlayToDisappear;
exports.proximalElementsWithInnerText = proximalElementsWithInnerText;
exports.hasParent = hasParent;
exports.getDepthRelativeToBody = getDepthRelativeToBody;
exports.isActive = isActive;
exports.isLikelyAutosuggestResult = isLikelyAutosuggestResult;
exports.isElementAPositionedGeometricallyInsideElementB = isElementAPositionedGeometricallyInsideElementB;
exports.doElementsGeometricallyOverlap = doElementsGeometricallyOverlap;
exports.isSiblingOf = isSiblingOf;
exports.TableElement = TableElement;
/* Webapi__Dom__Node Not a pure module */
